export default __webpack_public_path__ + "static/media/arrow.4cd81a74.svg";